import React from "react";
import styles from "./EmptyTable.module.scss";

interface EmptyTableProps {
  message: string;
  className?: string;
}

const EmptyTable: React.FC<EmptyTableProps> = ({ message, className = "" }) => {
  return (
    <div className={`${styles.empty_table_document} ${className}`}>
      <div className={`table_no_data ${styles.empty_table_msg}`}>
        {message}
      </div>
    </div>
  );
};

export default EmptyTable;
